import isEmail from 'helpers/isEmail'
import { createArrayValidator } from 'app/validators/base'
import { removeSymbolsFromPhone } from 'helpers/parsePhone'
import i18next from 'i18next'
import { ISO_CODE, formatByISO } from 'app/constants/phoneCountryCodes'

const rowsValidator = (context, row, index) => {
  const newContext = context.delete(index)
  const responseErrors = newContext.reduce((errors, value, key) => {
    const emailValue = value.get('email') && value.get('email').toLowerCase()
    const emailRow = row.get('email') && row.get('email').toLowerCase()
    if (emailValue && emailValue === emailRow) {
      errors = {
        email: i18next.t('should be unique'),
      }
    }
    if (
      value.get('phone') &&
      value.get('phone') === row.get('phone') &&
      value.get('phoneCode') === row.get('phoneCode')
    ) {
      errors = {
        phone: i18next.t('should be unique'),
      }
    }
    return errors
  }, {})
  if (Object.keys(responseErrors)) {
    return responseErrors
  }
}

const singleRowValidator = row => {
  const email = row.get('email')
  if (email && !isEmail(email)) {
    return {
      email: i18next.t('must be an email'),
    }
  }
  const phoneCode = row.get('phoneCode')
  const phone = row.get('phone')
  const parsedPhoneLength = phone && phoneCode && removeSymbolsFromPhone(phoneCode + phone).length

  if (phone && phoneCode === ISO_CODE.gb && !(phone.length >= 10)) {
    return {
      phone: i18next.t('must contain 10 or 11 digits for UK without country code'),
    }
  }

  if (phone && (phoneCode === ISO_CODE.gb && !(parsedPhoneLength === 13 || parsedPhoneLength === 14))) {
    return {
      phone: i18next.t('invalid phone number for GB'),
    }
  }

  if (phone && (phoneCode === ISO_CODE.usa && parsedPhoneLength !== formatByISO[ISO_CODE.usa].length)) {
    return {
      phone: i18next.t('invalid phone number for USA'),
    }
  }

  if (phone && (phoneCode === ISO_CODE.ua && parsedPhoneLength !== formatByISO[ISO_CODE.ua].length)) {
    return {
      phone: i18next.t('invalid phone number for Ukraine'),
    }
  }

  if (phone && (phoneCode === ISO_CODE.cn && parsedPhoneLength !== formatByISO[ISO_CODE.cn].length)) {
    return {
      phone: i18next.t('invalid phone number for China'),
    }
  }

  if (phone && (phoneCode === ISO_CODE.ru && parsedPhoneLength !== formatByISO[ISO_CODE.ru].length)) {
    return {
      phone: i18next.t('invalid phone number for Russia'),
    }
  }

  if (
    phone &&
    (phoneCode === ISO_CODE.es &&
      !(
        parsedPhoneLength === formatByISO[ISO_CODE.es].min + phoneCode.length ||
        parsedPhoneLength === formatByISO[ISO_CODE.es].max + phoneCode.length
      ))
  ) {
    return {
      phone: i18next.t('invalid phone number for Spain'),
    }
  }

  if (phone && (phoneCode === ISO_CODE.fr && parsedPhoneLength !== formatByISO[ISO_CODE.fr].length)) {
    return {
      phone: i18next.t('invalid phone number for France'),
    }
  }
}

export default createArrayValidator(singleRowValidator, rowsValidator)
